export { default } from './Tours';
